import { AdminSubscriptionsScreen } from '@features/admin/ui/AdminSubscriptionsScreen'

export function AssinaturasPage() {
  return <AdminSubscriptionsScreen />
}
